import { Suspense } from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';

// helpers
import { APICore } from '../helpers/api/apiCore';

// hooks
import { useUser } from '../hooks/auth';
import jwtDecode from 'jwt-decode';


type PrivateRouteProps = {
    roles?: string;
};

type User = {
    role: string;
    Note: string;
    Panel: string;
    Username: string;
    is_anak: string;
    hak_akses_desc: string;

};


const loading = () => <div className=""></div>;

/**
 * Private Route forces the authorization before the route can be accessed
 * @param {*} param0
 * @returns
 */
const PrivateRoute = ({ roles, ...rest }: PrivateRouteProps) => {
    let location = useLocation();
    const [loggedInUser] = useUser();



    const api = new APICore();

    /**
     * not logged in so redirect to login page with the return url
     */
    if (api.isUserAuthenticated() === false) {
        return <Navigate to={'/auth/login'} state={{ from: location }} replace />;
    }
    const user: User = jwtDecode(loggedInUser?.data)

    console.log('user', user)
    // check if route is restricted by role

    if (!loggedInUser) {
        return <Navigate to={'/auth/login'} state={{ from: location }} replace />;

    }
    if (roles && roles.indexOf(user.role) === -1) {
        // role not authorised so redirect to home page
        return <Navigate to={{ pathname: '/' }} />;
    }
    
    return (
        <Suspense fallback={loading()}>
            <Outlet />
        </Suspense>
    );
};

export default PrivateRoute;
